/*
 * Module for handling of ajax navigation links
 */
rs.module("ui/framework/links/ajax-navigation",

    [ /* no dependencies */],

    function () {

        // initialize the module
        function initialize() {
			$(document).onjs('click', 'ajaxLink', function () {
                var ajaxUrl = $(this).data("ajax");
                var urlHandlerModule = $(this).data("url-handler-module");

                // TODO: shell-hosted wait spinner here?
                $("body").css("cursor", "progress");

                // perform a GET or POST on the provided url, navigating to a returned response's location
                var execute = $(this).data("post") ? $.post : $.get;
                execute(ajaxUrl, null, function (data) {
                    if (data.url) {
                        if (!_delegateNavigation(data)) {
                            // No custom handler declared, just navigate with window.location
                            window.location = data.url;
                        }
                    }
                    else {
                        // if no url was resolved and an error callback module was defined, call it - sending along the data object that was returned
                        _onNavigationError(data);
                    }
                }).always(function () {
                    $("body").css("cursor", "default");
                });

                // Executes onAjaxNavigationError() on the urlHandlerModule, if one exists.
                function _onNavigationError(data) {
                    if (urlHandlerModule) {
                        var handler = rs.module(urlHandlerModule);
                        if (handler && handler.onAjaxNavigationError) {
                            handler.onAjaxNavigationError(data);
                        }
                    }
                }

                // Executes navigate() on the urlHandlerModule if one exists
                function _delegateNavigation(data) {

                    if (urlHandlerModule) {
                        var module = rs.module(urlHandlerModule);
                        if (module && module.navigate) {
                            return rs.module(urlHandlerModule).navigate(data);
                        }
                    }

                    return false;
                }
            });

            // Allow enter keypress to activate the link
            $(document).onjs('keypress', 'ajaxLink', function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(this).trigger('click');
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);